<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '90rem', maxWidth: '96vw', height: '90vh' }"
  [contentStyle]="{
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '0',
    overflow: 'hidden',
  }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  header="DFM Check"
>
  @if (loading) {
    <div class="flex items-center justify-center gap-2 py-12">
      <i class="pi pi-spin pi-spinner text-primary"></i>
      <span class="text-sm text-muted-color">Loading CAD geometry...</span>
    </div>
  } @else {
    <p class="mb-4 text-sm leading-relaxed text-muted-color">
      Run the enabled DFM checks for a Tangible material. Checks use a private
      analysis copy, so this node never changes CAD used by downstream moulding
      steps.
    </p>
    <div class="flex min-h-0 flex-1 flex-col gap-4 lg:flex-row">
      <div class="flex min-h-0 flex-[3_1_0%] flex-col gap-4">
        <div
          class="min-h-0 flex-[3_1_0%] overflow-hidden rounded-lg border border-surface-switch-200"
        >
          @if (cadObjects.length > 0) {
            <app-cad-viewer
              [cadObjects]="cadObjects"
              [visibleCadObjectIds]="visibleCadObjectIds"
              [dfmCheck]="selectedDfmCheck"
              [externallyHoveredCadObjectId]="hoveredCadObjectId"
              (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
            />
          } @else {
            <div
              class="flex h-full items-center justify-center p-6 text-center text-sm text-muted-color"
            >
              No CAD generated for this step yet.
            </div>
          }
        </div>
        <app-cad-object-tree
          class="block min-h-0 flex-[2_1_0%]"
          [cadObjects]="cadObjectRoots"
          [primaryCadObjectId]="primaryCadObjectId"
          [cadFileId]="cadFileId"
          [hoveredCadObjectId]="hoveredCadObjectId"
          (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
          (visibleCadObjectIdsChange)="visibleCadObjectIds = $event"
        />
      </div>
      <section
        class="flex min-h-0 flex-[2_1_0%] flex-col overflow-hidden pt-2 lg:w-[30rem]"
      >
        <p-tabs value="parameters" class="flex min-h-0 flex-1 flex-col">
          <p-tablist>
            <p-tab value="parameters">Parameters</p-tab>
            <p-tab value="properties">CAD Properties</p-tab>
          </p-tablist>
          <p-tabpanels class="min-h-0 flex-1 overflow-y-auto">
            <p-tabpanel value="parameters">
              <app-material-select
                label="DFM material"
                [value]="materialId"
                [includeInheritOption]="false"
                (valueChange)="onMaterialChange($event)"
              />
              <div class="mt-4">
                @if (status === "complete" && dfmChecks.length === 0) {
                  <p class="text-sm text-muted-color">
                    No DFM checks are enabled for this material.
                  </p>
                }
                @for (dfmCheck of dfmChecks; track dfmCheck.id) {
                  <app-dfm-check-item
                    [dfmCheck]="dfmCheck"
                    [selectedDFMCheck]="selectedDfmCheck"
                    [cadObjectName]="flowName"
                    (toggleDFMCheck)="onCheckToggled($event)"
                  />
                }
              </div>
            </p-tabpanel>
            <p-tabpanel value="properties">
              @if (displayCadObject) {
                <app-cad-properties [cadObject]="displayCadObject" />
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </section>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-between gap-3">
      <span class="text-sm text-muted-color">
        @if (isBusy) {
          <i class="pi pi-spin pi-spinner mr-1"></i>Running DFM checks…
        } @else if (status === "complete") {
          <i class="pi pi-check mr-1 text-green-600"></i>DFM checks complete
        } @else if (!materialId) {
          Select a material to run DFM checks.
        }
      </span>
      <div class="flex gap-2">
        @if (startErrorMessage || (status === "error" && data?.errorMessage)) {
          <span class="self-center text-sm text-red-600">
            {{ startErrorMessage ?? data?.errorMessage }}
          </span>
        }
        <p-button
          label="Close"
          severity="secondary"
          [outlined]="true"
          (onClick)="onVisibleChange(false)"
        />
        <span
          [pTooltip]="
            processing.downstreamExecutionActive()
              ? 'Downstream steps are running. Wait for the sequence to finish.'
              : undefined
          "
          tooltipPosition="top"
        >
          <p-button
            [label]="startLabel"
            [loading]="starting || isBusy"
            [disabled]="!canStart"
            (onClick)="onStart()"
          />
        </span>
      </div>
    </div>
  </ng-template>
</p-dialog>
